import { Grid, TextField, Select, MenuItem } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import { Controller } from "react-hook-form";

export const NrpForm = ({ control, errors, t }) => {
  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs={12} sm={6}>
        <Controller
          defaultValue=""
          control={control}
          name="state"
          render={({ field: { onChange, value } }) => (
            <>
              <InputLabel variant="standard" htmlFor="state">
                {t("App.infonavitUsers.table.state")}*
              </InputLabel>

              <Select
                inputProps={{
                  style: {
                    margin: "-5px 0 0 0 !important",
                    fontSize: 12,
                    border: "1px solid !important",
                  },
                }}
                value={value}
                className="select__filters__full"
                onChange={(event) => onChange(event.target.value)}
              >
                <MenuItem disabled value={""}>
                  <em>{t("App.createUser.selectOption")}</em>
                </MenuItem>

                <MenuItem value={true}>
                  {t("App.adminCompanies.filters.active")}
                </MenuItem>

                <MenuItem value={false}>
                  {t("App.adminCompanies.filters.inactive")}
                </MenuItem>
              </Select>
            </>
          )}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Controller
          name="nrp"
          control={control}
          render={({ field: { onChange, value } }) => (
            <>
              <InputLabel variant="standard" htmlFor="nrp">
                {t("App.infonavitUploadCredentials.formModal.form.nrpL")}
              </InputLabel>

              <TextField
                onChange={onChange}
                value={value}
                disabled={true}
                className="select__filters__full"
                InputLabelProps={{
                  style: {
                    margin: "-5px 0 0 -10px",
                    padding: "0 0 0 5px",
                    color: "#8c8d9d",
                    fontSize: 13,
                  },
                }}
              />
            </>
          )}
        />
      </Grid>
    </Grid>
  );
};
